
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PatientMedication',
  data () {
      return {
        medications: [
          {
            condition: 'Hypertension',
            name: 'Coveram 81mg tablet',
            dose: '81mg per day',
            prescriber: 'Dr Phoebe',
            prescribedOn: '2022-03-01'
          },
          {
            condition: 'Fever',
            name: 'Panadol',
            dose: '1 tablet 3per day',
            prescriber: 'Dr Prue',
            prescribedOn: '2023-03-01'
          },
          {
            condition: 'Headache',
            name: 'Panadol',
            dose: '1 tablet per day',
            prescriber: 'Dr Piper',
            prescribedOn: '2022-03-01'
          },
          {
            condition: 'LBM',
            name: 'Diatabs',
            dose: '1 tablet per day',
            prescriber: 'Dr Paige',
            prescribedOn: '2022-03-01'
          },
          {
            condition: 'Asthma',
            name: 'Beclomethazone thingy',
            dose: '40mcg',
            prescriber: 'Dr Phoebe',
            prescribedOn: '2021-01-01'
          },
          {
            condition: 'Hives',
            name: 'Ibuprofen',
            dose: '20 tsps per day',
            prescriber: 'Dr Piper',
            prescribedOn: '2022-03-01'
          },
        ],
      }
    },
})
